import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Icon from '../../Icon';
import TextField from '../../TextField';
import Box from '@material-ui/core/Box';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';

const WeekDay = ({ name, weekDay, value, onChange }) => {
  const defaultPeriod = { opening: '09:00', closing: '17:00' };
  const [periods, setPeriods] = useState(value.length > 0 ? value : [defaultPeriod]);
  const [isActive, setIsActive] = useState(value.length > 0);

  const handleChange = (ev, newValue) => {
    if (onChange) {
      onChange(ev, newValue);
    }
  };

  const handleActiveChange = () => {
    const newValue = !isActive;

    setIsActive(newValue);

    if (!newValue) {
      setPeriods([defaultPeriod]);

      if (onChange) {
        onChange(null, []);
      }
    } else {
      const updatedPeriods = [defaultPeriod];
      setPeriods(updatedPeriods);

      if (onChange) {
        onChange(null, updatedPeriods);
      }
    }
  };

  const append = newValue => {
    const updatedPeriods = [...periods, newValue];

    setPeriods(updatedPeriods);
    handleChange(null, updatedPeriods);
  };

  const remove = index => {
    const updatedPeriods = [...periods.slice(0, index), ...periods.slice(index + 1)];

    setPeriods(updatedPeriods);
    handleChange(null, updatedPeriods);
  };

  const update = (index, field) => (ev, newValue) => {
    const updatedPeriods = [
      ...periods.slice(0, index),
      { ...periods[index], [field]: newValue },
      ...periods.slice(index + 1),
    ];

    setPeriods(updatedPeriods);
    handleChange(ev, updatedPeriods);
  };

  const renderPeriod = (period, index) => (
    <Box key={`${name}_period`} display="flex" alignItems="center" px={1}>
      <TextField
        name={`${name}[${index}].opening`}
        margin="dense"
        disabled={!isActive}
        value={period.opening}
        onChange={update(index, 'opening')}
        register={false}
      />
      <Box px={1}>-</Box>
      <TextField
        name={`${name}[${index}].closing`}
        margin="dense"
        disabled={!isActive}
        value={period.closing}
        onChange={update(index, 'closing')}
        register={false}
      />
      {index !== 0 && (
        <IconButton onClick={() => remove(index)} disabled={!isActive}>
          <Icon icon={['fal', 'trash-alt']} size="small" />
        </IconButton>
      )}
    </Box>
  );

  return (
    <>
      <Box display="flex" alignItems="center" pt={1}>
        <Checkbox style={{ paddingLeft: 0 }} checked={isActive} onChange={handleActiveChange} />
        <div>{weekDay.shortLabel}</div>
      </Box>
      <div>{periods.map((period, idx) => renderPeriod(period, idx))}</div>
      <Box pt={1}>
        <IconButton onClick={() => append({ opening: '', closing: '' })} disabled={!isActive}>
          <Icon icon={['fal', 'plus']} size="small" />
        </IconButton>
      </Box>
    </>
  );
};

WeekDay.propTypes = {
  name: PropTypes.string.isRequired,
  weekDay: PropTypes.object.isRequired,
  value: PropTypes.array,
  onChange: PropTypes.func,
};

WeekDay.defaultProps = {
  value: [],
  onChange: undefined,
};

export default WeekDay;
